import React, { Component } from 'react';
import { activateInsuranceContract } from '../api';
import ConfirmModal from 'components/ConfirmModal/ConfirmModal';

class ActivateInsuranceContract extends Component {
  state = {
    loading: false,
    error: undefined,
    isOpenModal: false,
  };

  openModal = () => {
    this.setState({ isOpenModal: true });
  };

  closeModal = () => {
    this.setState({ isOpenModal: false });
  };

  activate = async () => {
    const { id, onSuccess } = this.props;

    try {
      this.setState({
        loading: true,
      });

      const response = await activateInsuranceContract(id);
      if (response.status === 200 || response.status === 201) {
        onSuccess(id);
      }
    } catch ({ response }) {
      const err = response.data;
      this.setState({
        loading: false,
        error:
          (err && (err.message || err.detail)) ||
          'An error occured activating the contract.',
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <React.Fragment>
        <h3>Activate Contract</h3>
        <button
          className="btn btn-success"
          onClick={this.openModal}
          disabled={this.state.loading}
        >
          Activate
        </button>
        <div className="text-danger">{this.state.error}</div>
        <ConfirmModal
          isOpen={this.state.isOpenModal}
          title="Confirm contract activation"
          description={`Are you sure you want to proceed with activating the device protection?`}
          onClose={this.closeModal}
          onConfirm={this.activate}
        />
      </React.Fragment>
    );
  }
}

export default ActivateInsuranceContract;
